import type { ToastProps } from '@/components/Toasts/Toasts.types';
import CONSTANTS from '@/helpers/constants';
import { nanoid } from 'nanoid';
import { defineStore } from 'pinia';

interface ToastInterface extends ToastProps {
  id: string;
}

export const useToastsStore = defineStore('toasts', () => {
  const toasts: Ref<ToastInterface[]> = ref([]);

  const show = (toast: ToastProps) => {
    const id = nanoid();

    // Check to see if the same toast is already being shown
    if (toasts.value.length) {
      const isToastTheSameAsLast = toasts.value[0].text === toast.text && toasts.value[0].accent === toast.accent;

      if (isToastTheSameAsLast) return;
    }

    toasts.value.unshift({ ...toast, id });

    setTimeout(() => {
      hide(id);
    }, toast.timeout ?? CONSTANTS.TOAST_DEFAULT_TIMEOUT);
  };

  const hide = (id: string) => {
    const targetIndex = toasts.value.findIndex((toast: ToastInterface) => toast.id === id);

    if (targetIndex !== -1) toasts.value.splice(targetIndex, 1);
  };

  return { toasts, show, hide };
});
